import apiClient from '../../../shared/api/client';

export const getPacienteInformeById = async (pacienteId) => {
  const { data } = await apiClient.get(`/pacientes/informes/${pacienteId}`);
  return data;
};

export const getValoraciones = async () => {
  const { data } = await apiClient.get('/valoracion');
  return data;
};

export const getValoracionById = async (valoracionId) => {
  const { data } = await apiClient.get(`/valoracion/${valoracionId}`);
  return data;
};

export const createValoracion = async ({ pacienteId, userId, payload }) => {
  const { data } = await apiClient.post(`/valoracion/${pacienteId}/${userId}`, payload);
  return data;
};

export const updateValoracion = async ({ codigoInforme, payload }) => {
  const { data } = await apiClient.put(`/valoracion/${codigoInforme}`, payload);
  return data;
};

export const deleteValoracion = async (codigoInforme) => {
  const { data } = await apiClient.delete(`/valoracion/${codigoInforme}`);
  return data;
};
